module.exports = __webpack_public_path__ + "static/img/101376.ad900d90.png";